import { get, post } from '../../utils/request'


// 查询所有公司简介信息(Interface Hea Banner Api Controller)
const groupInIe = post('/news/heaProfile/api/getAll')

// 组织机构列表(Interface Hea Organization Api Controller)
const organizationIe = get('/news/heaOrganization/api/list')

// 领导致辞列表 (Interface Hea Organization Api Controller)
const leaderTalkIe = get('/news/heaSpeech/api/list')
export {
  groupInIe,
  organizationIe,
  leaderTalkIe
}



// WEBPACK FOOTER //
// ./src/api/aboutus/aboutus.js